<template>
  <ion-page id="selectlanguage-page">
    <ion-content>

      <div v-if="showState == SHOW_EXPLAINTOUR">
        <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />
      </div>
      <div v-show="showState == SHOW_LANGUAGES" :class="{ 'text-dark' : isDark,'text-light' : !isDark }">
        <TopLine :style="styleTopline" :title="selectLanageTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
        <ion-list id="select-language" :style="styleLanguagesAvailable">
          
          <ion-item>
            <ion-label color="danger">
              <h2><b>{{ translatePhrase("When you ' Update ' the language, the program will restart!") }}"</b></h2>
            </ion-label>
          </ion-item>

          <ion-item v-for="item in languageItems" v-bind:key="item.index" @click="onClick(item.index)"
                 :class="{
                  'selected-text-dark' : item.selected && isDark,
                  'selected-text-light' : item.selected && !isDark
                  }"
              >
            <ion-label>
              {{ item.display }} 
            </ion-label>
          </ion-item> 
        </ion-list>
        <div  :style="styleLanguageSelected">
          <ion-item>
            <ion-label>
              <span v-show="currentSelectedLanguage == originalLanguage">
                  <b>{{ translateEnglishWords("Current Language") }} : </b>
              </span>
              <span v-show="currentSelectedLanguage != originalLanguage">
                  <b>{{ translateEnglishWords("Update language to") }} : </b>
              </span>
              {{ languageDisplayName }}
            </ion-label>
          </ion-item>
        </div>
        <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </div>
    </ion-content>
  </ion-page>
  
</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  import { computed } from "@vue/reactivity"
  import { useGetData , generateErrorAlertText } from '../../composables/getData.js'

  import { ref, watch } from 'vue'
  import ExplainTour from '@/components/ExplainTour.vue'
  import ToolBar from '@/components/ToolBar.vue'
  import { useRouter } from 'vue-router';
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import TopLine from '@/components/TopLine.vue'
  import { parseWordsSaid , buildWordListFromChoiceList, parseNumberWords } from '@/composables/wordlistSupport.js'
import { translateEnglishWords , translatePhrase } from '@/composables/translation';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()  
  const windowSizeStore = useWindowSizeStore()

  const isDark = ref(connectionStore.getDarkmode != "light")

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const wordlistTrigger = ref(0)
  const wordlistVoices = "command scroll up down language explain done update ignore mute listen system english spanish italian german french portuguese";
  const wordlist = ref(wordlistVoices)
  emit("word-list",wordlistVoices)

  const SHOW_LANGUAGES = 0
  const SHOW_EXPLAINTOUR = 1
  const showState = ref(SHOW_LANGUAGES)

  const TOOLBAR_UPDATE_LANGUAGE = 0
  const TOOLBAR_EXPLAINTOUR = 1

  const toolbarElements = ref([
    { index : TOOLBAR_UPDATE_LANGUAGE, label : translateEnglishWords("Update Language") ,disabled : true},
    { index : TOOLBAR_EXPLAINTOUR, label : translateEnglishWords("Explain") ,disabled : false},
  ])

  const selectLanageTitle = ref(translateEnglishWords("Select Language"))
  const originalLanguage = connectionStore.getLanguageInUse

  const toolbarTrigger = ref(0)
  const isLoading = ref(true)
  const currentSelectedLanguage = ref(originalLanguage)

  var scrollTop = 0

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)


  const languageDisplayName = ref("")

  const languageItems = ref([
      { index : 0, display : translateEnglishWords("System"), abbr : "",   name : "system", selected : false},
      { index : 1, display : translateEnglishWords("English"), abbr : "en", name : "english" , selected : false},
      { index : 2, display : translateEnglishWords("Spanish"), abbr : "es", name : "spanish" , selected : false},
      { index : 3, display : translateEnglishWords("French"), abbr : "fr", name : "french" , selected : false},
      { index : 4, display : translateEnglishWords("Italian"), abbr : "it", name : "italian" , selected : false},
      { index : 5, display : translateEnglishWords("German"), abbr : "de", name : "german" , selected : false},
      { index : 6, display : translateEnglishWords("Portuguese"), abbr : "pt", name : "portuguese" , selected : false},
  ])

  for (var i=0; i < languageItems.value.length; i++)
    if (originalLanguage == languageItems.value[i].abbr) {
      languageDisplayName.value = languageItems.value[i].display
      break
    }

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleLanguagesAvailable = ref(buildStyleMiddle(availableWidthHeight()))
  const styleLanguageSelected = ref(buildStyleMiddle(availableWidthHeight()))
  updateWidthHeights()

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })
  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** Explorer -- window size changes detected')
      updateWidthHeights()
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {
  }

  function updateWidthHeights() {

    const heightOfSelected = 50
    const availableSpace = availableWidthHeight()

    styleToolbar.value = buildStyleToolbar(availableSpace)
    styleTopline.value = buildStyleTopline(availableSpace)
    styleLanguagesAvailable.value = buildStyleMiddle(availableWidthHeight())
    styleLanguageSelected.value = buildStyleMiddle(availableWidthHeight())

    const availableHeight = (availableSpace.height - heightOfSelected)
    const selectedTop = (availableSpace.topIndent + availableSpace.height - heightOfSelected)
    styleLanguagesAvailable.value.height = availableHeight + "px"
    styleLanguageSelected.value.top =  selectedTop+ "px"
    styleLanguageSelected.value.height = heightOfSelected + "px"
  }

  // START Explain Tour Routines

  function explainTourInitialize(errorText) {
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? "select_language" : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlistVoices)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_LANGUAGES
        wordlist.value = wordlistVoices
        emit("word-list",wordlistVoices)
        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_UPDATE_LANGUAGE :
        processWords("command update")
        break
      case TOOLBAR_EXPLAINTOUR :
        processWords("command explain")
        break
    }
 
  }

  function onClick(index) {

    for (var i=0; i < languageItems.value.length; i++)
      languageItems.value[i].selected = false

    languageItems.value[index].selected = true

    languageDisplayName.value = languageItems.value[index].display
    currentSelectedLanguage.value = languageItems.value[index].abbr
    //console.log("click on ",index)

    toolbarElements.value[TOOLBAR_UPDATE_LANGUAGE].disabled = 
              currentSelectedLanguage.value == originalLanguage
    toolbarTrigger.value++
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "explain") {
            return ["explain",""]
        }
        if (currentWord == "done" || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""]

        if (currentWord == "scroll") {
            if (nextWord == "up") {
                return ["scroll", "up"]
            }
            if (nextWord == "down") {
                return ["scroll", "down"]
            }
        }
        
        // add choices here
        if (currentWord == "update") {
          return (["update",""])
        }
        if (currentWord == "system" || currentWord == "english" || currentWord == "spanish" ||
                currentWord == "italian" || currentWord == "french" || currentWord == "german"
              || currentWord == "portuguese") {
          return [currentWord, ""]
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processWords(text) {
    //console.log("text in engine Menu ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    if (showState.value == SHOW_EXPLAINTOUR) {
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      return;
    }

    switch (returnArray[0]) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "scroll" :
        scrollElement("select-language",returnArray[1])
        break
      case "system" :
        onClick(0)
        break
      case "english" :
        onClick(1)
        break
      case "spanish" :
        onClick(2)
        break
      case "italian" :
        onClick(4)
        break
      case "french" :
        onClick(3)
        break
      case "german" :
        onClick(5)
        break
      case "portuguese" :
        onClick(6)
        break
      case "update" :
        if (currentSelectedLanguage.value == originalLanguage)
          return
        // zap the voices too
        connectionStore.setLanguageIncludingSystem(currentSelectedLanguage.value)
        setLanguageOnServer()
        break
      case "explain" :
        explainTourInitialize(null)
        break
    }
  }

  function processLanguageJsonResponse (json) {

    // in case this came from somebody on the landing page
    connectionStore.setRunRequestFromLandingPage("yes")

    emit("where-next","/restartasr")
  }

  //
  function setLanguageOnServer() {
    var formData = {
      language : currentSelectedLanguage.value,
    }

    //console.log("Set language ",formData)
    useGetData("set_verbal_language.php", formData,processLanguageJsonResponse)
  }

</script>

<style scoped>

.selected-text-light {
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.selected-text-dark {
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

ion-label {
    cursor: pointer;
    margin: 0px;
    padding : 0px;
 }

</style>
